import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=dc9837a4&scoped=true&"
import script from "./Customization.vue?vue&type=script&lang=ts&"
export * from "./Customization.vue?vue&type=script&lang=ts&"
import style0 from "./Customization.vue?vue&type=style&index=0&id=dc9837a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9837a4",
  null
  
)

export default component.exports